import React from 'react';

export default function Pagination({ page, total, limit, onPageChange }) {
  const totalPages = Math.ceil(total / limit);
  if (totalPages <= 1) return null;

  return (
    <div className="pagination">
      <button className="page-btn" disabled={page === 1} onClick={() => onPageChange(page - 1)}>‹ Prev</button>
      {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
        const p = Math.max(1, Math.min(page - 2, totalPages - 4)) + i;
        if (p > totalPages) return null;
        return (
          <button key={p} className={`page-btn ${p === page ? 'active' : ''}`} onClick={() => onPageChange(p)}>{p}</button>
        );
      })}
      <button className="page-btn" disabled={page === totalPages} onClick={() => onPageChange(page + 1)}>Next ›</button>
    </div>
  );
}
